import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import colors from "vuetify/es5/util/colors";
import fr from "vuetify/es5/locale/fr";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi" || "fa"
  },
  lang: {
    current: "fr",
    locales: { fr }
  },
  theme: {
    themes: {
      light: {
        tertiary: colors.grey.darken1,
        secondary: colors.grey.darken3,
        primary: "#37474F",
        accent: "#37474F",
        success: "#46c93a",
        error: "#ff4757",
        warning: "#ff8200",
        background: "#FFF"
      },
      dark: {
        tertiary: colors.grey.darken1,
        secondary: colors.grey.darken3,
        primary: "#37474F",
        accent: "#37474F",
        success: "#46c93a",
        error: "#ff4757",
        warning: "#ff8200",
        background: "#454851"
      }
    }
  }
});
